import React, { useEffect } from 'react'
import "../App.css";
import socketIOClient from 'socket.io-client'
import VideoPlayer from '../components/TestPlayer'

const socket = socketIOClient("https://socket-io.i-iptv.com");

const Test = () => {
  useEffect(() => {
    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off('message');
    };
  });

  const videoJsOptions = {
    autoplay: true,
    muted: true,
    controls: true,
    responsive: true,
    sources: [
      {
        src: 'https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8',
      },
    ],
  };

  return (
    <div className="">
      <VideoPlayer id="video-area" className="" type="vod" {...videoJsOptions} />
    </div>
  )
}

export default Test
